export const XFoldspaceSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 70) * 104}
      viewBox="0 0 70 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_283_4)">
        <mask id="path-1-inside-1_283_4" fill="white">
          <rect x="1" y="1" width="68" height="102" rx="1" />
        </mask>
        <rect x="1" y="1" width="68" height="102" rx="1" fill="black" />
        <rect
          x="1"
          y="1"
          width="68"
          height="102"
          rx="1"
          stroke="white"
          strokeOpacity="0.92"
          strokeWidth="4"
          mask="url(#path-1-inside-1_283_4)"
        />
      </g>
      <path
        d="M50.5 43.7618C49.6056 47.3395 44.1667 50.9285 42.5 50.7618C44 51.9285 46.9956 52.514 49.5 51.2618C51.5 50.2618 53.1667 47.9285 54.5 46.7618C54.5 49.0952 53.5 54.7618 50.5 56.7618C45.9732 59.7797 41 58.0952 40.5 56.7618C39.3333 57.9285 37.4006 60.5289 40 62.2618C43 64.2618 47 64.2618 51.5 63.7618C49 65.2618 44 69.2618 38 67.2618C34.2626 66.016 32 61.2618 33.5 58.2618C31 58.2618 27.5 59.7618 26.5 63.2618C25.4869 66.8078 29.5 67.7618 32 70.7618C29 70.7618 21.5 69.2618 21.5 63.7618C21.5 59.2618 26.6667 55.9285 28.5 54.7618C27 53.7618 24 54.2618 22 55.2618C17.3352 57.5942 16.6667 60.2618 16 61.2618C16.1667 59.5952 17.5 55.2618 21.5 51.2618C25.5 47.2618 27.5 47.2618 30 47.7618C30 45.7618 29 43.7618 27 43.7618C23 43.7618 19.5 46.0952 18 46.7618C19.1667 45.2618 25 40.2618 29 40.2618C33 40.2618 35 42.5952 35.5 43.7618C36.6667 42.5952 40.5 41.0619 38.5 38.2619C36 34.7618 30 35.2618 29.5 34.7618C31.5 34.4285 38 32.7618 41.5 35.7618C45.5 39.1904 41.5 43.2619 40.5 45.2619C43.5 44.7619 45.7062 44.2025 47 42.2618C49 39.2619 48.5 37.0952 48.5 34.7618C49.5 37.2618 51.5 39.7618 50.5 43.7618Z"
        fill="url(#paint0_linear_283_4)"
      />
      <defs>
        <filter
          id="filter0_di_283_4"
          x="0"
          y="0"
          width="70"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_283_4"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_283_4"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_283_4"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_283_4"
          />
        </filter>
        <linearGradient
          id="paint0_linear_283_4"
          x1="35.25"
          y1="34"
          x2="35.25"
          y2="70.7618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#913537" />
          <stop offset="1" stopColor="#D54451" />
        </linearGradient>
      </defs>
    </svg>
  );
};
